import React from 'react';
import { CSSProperties } from 'styled-components';
import diskImage from '../../assets/img/disc_1.png';
import './DiscStyle.css';

interface Props {
    onClick: () => void;
    spinning: boolean;
    size: number | string;
    halfSize: number | string;
    style?: CSSProperties;
}

export default class Disc extends React.Component<Props, {}> {
    public render() {
        return (
            <div
                onClick={this.props.onClick}
                style={{
                    borderRadius: this.props.halfSize,
                    height: this.props.size,
                    width: this.props.size,
                    margin: '0 auto',
                    ...this.props.style,
                }}>
                <img
                    src={diskImage}
                    alt="disk"
                    className="disc"
                    style={{
                        animationPlayState: this.props.spinning ? 'running' : 'paused',
                        height: this.props.size
                    }}
                />
            </div>
        )
    }

}


